import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ViewInformationDialogComponent } from './parts/view-information-dialog/view-information-dialog.component';

@Component({
  selector: 'coin-a-view-information',
  templateUrl: './view-information.component.html',
  styleUrls: ['./view-information.component.scss'],
  standalone: false
})
export class ViewInformationComponent {
  private matDialog = inject(MatDialog);

  @Input() translationPrefix: string;

  public openInformationDialog(): void {
    this.matDialog.open(ViewInformationDialogComponent, {
      width: '50vw',
      maxWidth: '2000px',
      data: { translationPrefix: this.translationPrefix }
    });
  }
}
